module.exports = "/images/sort-up-solid.svg?cf41079dcef27595a601820912f31a76";


//////////////////
// WEBPACK FOOTER
// ./public/icons/sort-up-solid.svg
// module id = Xolr
// module chunks = 0